import { FILE_MIME_TYPES, FILE_SIZE_BYTES } from "shared/lib/constants/files";
import { ImageMimeTypeI } from "shared/lib/interfaces/files";

export const validateSelectedAvatar = (file: File, maxFileSizeMB: number) => {
  const conditions = {
    format: Object.values(FILE_MIME_TYPES.IMAGE).includes(
      file.type as ImageMimeTypeI
    ),
    size: file.size <= FILE_SIZE_BYTES.ONE_MEGABYTE * maxFileSizeMB,
  };

  return {
    isValid: conditions.format && conditions.size,
    conditions,
  };
};
